import { showSuccess, showWarning } from 'containers/Toaster/actions';
import { call, put, select } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';

import { takeEvery } from 'containers/ErrorBoundary';
import { selectLanguage } from 'containers/LanguageProvider/selectors';
import { translationMessages } from 'i18n';
import get from 'lodash/get';
import { assoc } from 'ramda';
import { UPLOAD_CA } from './constants';

export function* uploadCASaga(action) {
  const language = yield select(selectLanguage);
  const msg = translationMessages[language.get('locale')].fileUploadOverlay;
  try {
    const { data } = action.payload;
    const ca = yield call(requestForSaga, {
      url: '/settings/ca',
      method: 'POST',
      data,
    });
    yield put({
      type: `${UPLOAD_CA}_SUCCESS`,
      payload: assoc('ca', ca, action.payload),
    });
    yield put(
      showSuccess({
        message: get(msg, 'msgCertificateUploaded', 'Certificate uploaded'),
      }),
    );
  } catch (e) {
    yield put({ type: `${UPLOAD_CA}_ERROR` });
    if (e.code === 'API_RESOURCE_CONFLICT') {
      yield put(
        showWarning({
          message: get(
            msg,
            'msgNameAlreadyExist',
            'Upload failed, please use different name. The specified is already stored',
          ),
        }),
      );
    } else {
      yield call(requestCustomErrorMessage, 'danger', e);
      throw e;
    }
  }
}

export function* defaultSaga() {
  yield takeEvery(UPLOAD_CA, uploadCASaga);
}

// All sagas to be loaded
export default defaultSaga;
